import React from "react";
import { Box } from "@mui/material";
import UserDataTable from "../components/user/UserDataTable";
import apiConfig from "../config/appConfig";

const Users = () => {
  const apiUrl = apiConfig.endpoints.users.paginated;

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <UserDataTable apiUrl={apiUrl} />
    </Box>
  );
};

export default Users;